export default __webpack_public_path__ + "static/media/Deepthi Joseph.9058d4e4.jpg";